import HomePage from '@/components/HomePage'
import PageNotFound from '@/components/PageNotFound'
import Login from '@/components/auth/Login'
import CompaniesList from '@/apps/orgstructure/components/CompaniesList'

import Layout from '@/components/Layout/index'
import AccountsRoutes from '@/apps/accounts/routes' // Управление аккаунтами

export default [
  {
    path: '/',
    redirect: '/lk'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/lk',
    name: 'Dashboard',
    component: Layout,
    children: [
      {
        path: '',
        name: 'HomePage',
        component: HomePage
      },
      AccountsRoutes,
      {
        path: 'companies',
        name: 'CompaniesList',
        component: CompaniesList
      }
    ]
  },
  {
    path: '*',
    name: 'notFound',
    component: PageNotFound
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js